import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FixedBridgesContent from '../components/FixedBridgesContent';

const FixedBridges = () => {
  return (
    <div className="xrays-container" style={{ backgroundColor: "#edffee" }}>
      <Header />
      <FixedBridgesContent />
      <Footer />
    </div>
  );
};

export default FixedBridges;